import { Typography } from '@mui/material';
import styled, { css } from 'styled-components';

import {
  ColumnHeader as OrganizationColumnHeader,
  ToggleExpand as OrganizationToggleExpand,
} from 'app/definitions/organization/organizationHeader/OrganizationHeader.styles';
import {
  PRESENCE_ACTION_COLUMN,
  PRESENCE_CODE_COLUMN_WIDTH,
  PRESENCE_COUNTERS_COLUMNS,
  PRESENCE_NAME_AREA_WIDTH,
} from '../CurrentPresence.variables';

export const Header = styled.div`
  display: grid;
  grid-template-columns: 70px 1fr;
  align-items: center;
  margin: 8px 0 6px;
  /* Tree rows have 8px padding and a 1px border on each side — keep the columns on the same x. */
  padding-right: 9px;
`;

export const ExpandAllWrapper = styled.div`
  width: 100%;
`;

export const ToggleExpand = styled(OrganizationToggleExpand)`
  width: 52px;
  height: 28px;
  border-radius: 4px;
`;

export const ColumnsWrapper = styled.div`
  display: grid;
  grid-template-columns: ${PRESENCE_NAME_AREA_WIDTH}px ${PRESENCE_COUNTERS_COLUMNS} 1fr ${PRESENCE_ACTION_COLUMN};
  align-items: center;
`;

export const NameColumns = styled.div`
  display: grid;
  grid-template-columns: ${PRESENCE_CODE_COLUMN_WIDTH}px 1fr;
`;

export const CountersBackground = styled.div(
  ({ theme: { palette } }) => css`
    display: grid;
    grid-column: 2 / 6;
    grid-template-columns: ${PRESENCE_COUNTERS_COLUMNS};
    align-items: center;
    height: 28px;
    border-radius: 4px;
    background-color: ${palette.grey[200]};
  `,
);

/** KOD / NAZWA headers look exactly like Definicje → Strefy. */
export const NameColumnHeader = OrganizationColumnHeader;

/** `bold` — "ILOŚĆ OSÓB" (700), `medium` — STREFA / PODSTREFA / ŁĄCZNIE (500). */
type ColumnHeaderWeight = 'medium' | 'bold';

const COLUMN_HEADER_FONT_WEIGHT: Record<ColumnHeaderWeight, number> = { medium: 500, bold: 700 };

export const ColumnHeader = styled(Typography)<{ $weight: ColumnHeaderWeight }>(
  ({ theme: { palette }, $weight }) => css`
    font-size: 12px;
    text-transform: uppercase;
    color: ${palette.grey[900]};
    font-weight: ${COLUMN_HEADER_FONT_WEIGHT[$weight]};
    padding-left: 15px;
  `,
);
